var map = {
	"./art-statement.jpeg": "5842",
	"./bio.jpeg": "c80e",
	"./connect.jpeg": "3261",
	"./film-reviews.jpeg": "a0df",
	"./inspiration.jpeg": "043d",
	"./odyssey.jpeg": "b381",
	"./the-film.jpeg": "1e07"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2192";